
<div class="banner"></div>
<app-header-galery [hosting]="hosting"></app-header-galery>

<!-- Galería principal -->
<div class="img-container">
  <img
    *ngIf="images.length > 0"
    [src]="images[currentModalImageIndex]"
    [alt]="hosting?.name"
    class="galery-first-img"
    (click)="openModal(currentModalImageIndex)"
  >
  <div class="gallery-controls" *ngIf="images.length > 1">
    <button class="prev-btn" (click)="prevImage()">&#10094;</button>
    <span class="image-counter">{{ currentModalImageIndex + 1 }}/{{ images.length }}</span>
    <button class="next-btn" (click)="nextImage()">&#10095;</button>
  </div>
</div>

<!-- Galería Modal -->
@if (modalOpen) {
  <div class="modal-gallery show"> 
    <span class="close-btn" (click)="closeModal()">&times;</span>
    <span class="prev-btn" *ngIf="images.length > 1" (click)="prevImage()">&#10094;</span>
    <span class="next-btn" *ngIf="images.length > 1" (click)="nextImage()">&#10095;</span>
    <div class="counter">{{ currentModalImageIndex + 1 }}/{{ images.length }}</div>
    <img [src]="getCurrentImage()" alt="Modal Image">
  </div>
}